import { nanoid } from "nanoid";
import React from "react";
import GaugeChart from "react-gauge-chart/dist/GaugeChart";
import { addTopic, removeTopic } from "../../utils/socket.services";
import { getOneThing } from "../../utils/useful";


class GaugeWidget extends React.Component {

    state = {
        value: 0,
        topicId: nanoid(10)

    }

    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data?.thing != this.props.data?.thing) {
            this.init()
        } else if (prevProps.data != this.props.data) {
            this.calcPercentage()
        }
    }

    componentWillUnmount(){
        removeTopic(this.state.topicId,this.props.data.thing, 'things')
    }

    init() {
        this.setState({ thing: {}, data: {} }, () => {
            getOneThing({ id: this.props.data.thing }, (fetchResult, fetchError, status) => {
                // console.log(fetchResult)
                if (fetchResult) {
                    this.setState({ thing: fetchResult.info, data: fetchResult.info.latestData ?? {} }, () => {
                        this.calcPercentage()
                    })
                    addTopic(this.state.topicId, this.props.data.thing, 'things', null, this.updateData)

                }
            })
        })
    }


    updateData = (newData) => {
        // console.log(newData)
        let data = this.state.data
        data = { ...data, ...newData }
        // console.log(data)

        this.setState({ data }, () => {
            this.calcPercentage()
        })
    }

    calcPercentage() {
        let value = 'N/A'
        let percentage = '0'

        if (this.state.data && this.state.data[this.props.data.characteristic]!=null) {
            let min = this.props.data.min ?? 0
            let max = this.props.data.max ?? 100

            value = this.state.data[this.props.data.characteristic]

            percentage = this.state.data[this.props.data.characteristic] / (max - min)
            // console.log(this.props.data)
        } else {

        }
        // console.log(value)
        // console.log(percentage)
        this.setState({ value, percentage })

    }



    render() {

        return (
            <div className="w-100 flexcc" style={{ flex: 1 }} >
                <GaugeChart id="gauge-chart3"
                    nrOfLevels={20}
                    colors={['#007aff', '#00C76D']}
                    arcWidth={0.25}
                    percent={this.state.percentage}
                    textColor={'#678'}
                    needleColor={'#bcd'}
                    animDelay={0}
                    arcPadding={0.01}
                    needleBaseColor={'#F87C56b7f'}
                    formatTextValue={value => this.state.value + (this.props.data?.unit ? this.props.data?.unit : '')}
                />

            </div >
        )
    }
}



export default GaugeWidget;
